<template>
  <f7-page>
    <navbar :text="$t('DxCrops_title')" />
    <f7-block
      v-if="loaded"
      class="content-devx"
    >
      <f7-row>
        <f7-col width="50">
          <DxCropsSelector
            :crops-options="cropsOptions"
            :initial-crops="currentCrops"
          />
        </f7-col>
      </f7-row>
      <f7-row v-if="currentCrops.length > 0">
        <f7-col width="100">
          <DxCropsEdition
            :current-crops="currentCrops"
            :crops-data="cropsData"
            :barbecho-data="barbechoData"
          />
        </f7-col>
      </f7-row>
      <f7-row v-if="currentCrops.length > 0">
        <f7-col width="100">
          <f7-block-title>
            <f7-link :tooltip="$t('Crops_Helps_Tips_officialHistoricalPrices')">
              <i
                style="font-size: 20px"
                class="icon material-icons icon-tooltip if-md"
              >info</i>
            </f7-link>
            {{ $t('Crops_title_historicalPrice') }}
          </f7-block-title>
          <DxCropsHistoricalPrices
            :current-crops="currentCrops"
            :crops-data="cropsData"
          />
        </f7-col>
      </f7-row>
    </f7-block>
    <f7-button
      v-if="currentCrops.length > 0 && isValidData"
      class="dx-btn-cancel"
      raised
      type="default"
      text-color="grey"
      styling-mode="outlined"
      @click="goToOptimalCropDistribution"
    >
      {{ $t('Save') }}
    </f7-button>
  </f7-page>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import navbar from '../components/NavBar.vue';
import DxCropsSelector from '../components/Crops/DxCropsSelector.vue';
import DxCropsEdition from '../components/Crops/DxCropsEdition.vue';
import DxCropsHistoricalPrices from '../components/Crops/DxCropsHistoricalPrices.vue';

export default {
  components: {
    navbar,
    DxCropsSelector,
    DxCropsEdition,
    DxCropsHistoricalPrices,
  },
  data() {
    return {
      loaded: false,
    };
  },
  computed: {
    getCropsData() {
      const currentCropsData = {};
      for (const currentCrop of this.currentCrops) {
        currentCropsData[currentCrop] = this.cropsData[currentCrop];
      }
      return currentCropsData;
    },
    getFloorData() {
      return {
        currentFloor: this.currentFloor,
        currentUsefulLife: this.currentUsefulLife,
        currentPercentageOfStoniness: this.currentPercentageOfStoniness,
      };
    },
    getIrrigationData() {
      return {
        currentAvailableVolume: this.currentAvailableVolume,
        currentIrrigationWaterCost: this.currentIrrigationWaterCost,
        currentMaximumIrrigation: this.currentMaximumIrrigation,
        currentMinimumIrrigation: this.currentMinimumIrrigation,
        currentMaximumIrrigationDose: this.currentMaximumIrrigationDose,
        currentMinimumIrrigationDose: this.currentMinimumIrrigationDose,
        currentEfficiency: this.currentEfficiency,
        currentSuboptimizationModel: this.currentSuboptimizationModel,
        currentNumberOfPointsInTheFunction: this.currentNumberOfPointsInTheFunction,
        currentInitialSoilMoisture: this.currentInitialSoilMoisture,
        currentSoilWaterFillLevel: this.currentSoilWaterFillLevel,
        currentSoilWaterDepletionLevel: this.currentSoilWaterDepletionLevel,
      };
    },
    isValidData() {
      if (this.$helpers.validateFloorData(this.getFloorData) !== '') return false;
      if (this.$helpers.validateIrrigationData(this.getIrrigationData) !== '') return false;
      return true;
    },
    ...mapState('Mopeco', ['cropsOptions', 'currentCrops', 'cropsData', 'barbechoData']),
    ...mapState('Mopeco', ['currentFloor', 'currentUsefulLife', 'currentPercentageOfStoniness']),
    ...mapState('Mopeco', ['currentAvailableVolume', 'currentIrrigationWaterCost', 'currentMaximumIrrigation', 'currentMinimumIrrigation', 'currentMaximumIrrigationDose',
      'currentMinimumIrrigationDose', 'currentEfficiency', 'suboptimizationModelOptions', 'currentSuboptimizationModel',
      'currentNumberOfPointsInTheFunction', 'currentInitialSoilMoisture', 'currentSoilWaterFillLevel', 'currentSoilWaterDepletionLevel']),
  },
  async beforeMount() {
    this.$f7.preloader.show();
    try {
      await this.setCropsOptions();
    } catch (error) {
      if (error.message.includes('500')) {
        this.$f7.dialog.alert(this.$t('error_500'));
      } else {
        this.$f7.dialog.alert(this.$t(`${error}`));
      }
    } finally {
      this.$f7.preloader.hide();
      this.loaded = true;
    }
  },
  methods: {
    async goToOptimalCropDistribution() {
      this.setShowOptimalCropDistribution(false);
      let errorMessage = this.$helpers.validateFloorData(this.getFloorData);
      if (errorMessage !== '') {
        this.$f7.dialog.alert(this.$t(errorMessage));
        return;
      }
      errorMessage = this.$helpers.validateIrrigationData(this.getIrrigationData);
      if (errorMessage !== '') {
        this.$f7.dialog.alert(this.$t(errorMessage));
        return;
      }
      errorMessage = this.validateBasicCropData(this.barbechoData);
      if (errorMessage !== '') {
        this.$f7.dialog.alert(this.$t(errorMessage));
        return;
      }
      for (const crop of this.currentCrops) {
        errorMessage = this.validateBasicCropData(this.cropsData[crop]);
        if (errorMessage !== '') {
          this.$f7.dialog.alert(this.$t(errorMessage));
          return;
        }
        errorMessage = this.validateEconomicalData(this.cropsData[crop].economicalData);
        if (errorMessage !== '') {
          this.$f7.dialog.alert(this.$t(errorMessage));
          return;
        }
      }
      this.$f7.preloader.show();
      try {
        await this.setMopecoModel();
        this.setShowOptimalCropDistribution(true);
        this.$f7.views.main.router.navigate('/optimalCropDistribution/');
      } catch (error) {
        if (error.message.includes('500')) {
          this.$f7.dialog.alert(this.$t('error_500'));
        } else {
          this.$f7.dialog.alert(this.$t(`${error}`));
        }
      } finally {
        this.$f7.preloader.hide();
        this.loaded = true;
      }
    },
    validateEconomicalData(economicalData) {
      for (const year in economicalData) {
        if (Object.hasOwnProperty.call(economicalData, year)) {
          const element = economicalData[year];
          if (typeof element.productSellingPrice === 'undefined' || element.productSellingPrice < 0 || element.productSellingPrice > 100) return 'Crops_Validate_Error_HistoricalPrice';
          if (typeof element.subproductSellingPrice === 'undefined' || element.subproductSellingPrice < 0 || element.subproductSellingPrice > 100) return 'Crops_Validate_Error_HistoricalPrice';
        }
      }
      return '';
    },
    validateBasicCropData(cropData) {
      if (typeof cropData.cropAids === 'undefined' || cropData.cropAids < 0 || cropData.cropAids > 100000) return 'Crops_Validate_Error_CropAids';
      if (typeof cropData.totalIrrigationLimit === 'undefined' || cropData.totalIrrigationLimit < 0 || cropData.totalIrrigationLimit > 100000000) return 'Crops_Validate_Error_TotalIrrigationLimit';
      if (typeof cropData.cost === 'undefined' || cropData.cost < 0 || cropData.cost > 100000) return 'Crops_Validate_Error_CropCosts';
      if (typeof cropData.calendarFirstDate === 'undefined') return 'Crops_Validate_Error_SeedTime';
      if (typeof cropData.surfaceLimit === 'undefined' || cropData.surfaceLimit < 0) return 'Crops_Validate_Error_MaxSurface';
      if (typeof cropData.maxPerformance === 'undefined' || cropData.maxPerformance < 0) return 'Crops_Validate_Error_MaxPerformance';
      return '';
    },
    ...mapActions('Mopeco', ['setCropsOptions', 'setShowOptimalCropDistribution', 'setMopecoModel']),
  },
};
</script>

<style>

</style>
